/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./blocks/masonry-gallery/frontend.css":
/*!*********************************************!*\
  !*** ./blocks/masonry-gallery/frontend.css ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!********************************************!*\
  !*** ./blocks/masonry-gallery/frontend.js ***!
  \********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _frontend_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./frontend.css */ "./blocks/masonry-gallery/frontend.css");
/**
 * Masonry Gallery Lightbox
 * Lightweight, accessible lightbox for gallery images
 */


(function () {
  'use strict';

  // Store gallery data
  let currentIndex = 0;
  let galleryImages = [];
  let lightboxElement = null;
  let resizeTimer = null;

  /**
   * Justified gallery layout:
   * Packs images into rows that always fill the container width.
   */
  function layoutJustified(gallery) {
    if (!gallery) return;
    const items = Array.from(gallery.querySelectorAll('.gallery-item'));
    if (!items.length) return;
    const gap = 4; // must match PHP $gap
    const containerWidth = gallery.clientWidth;
    if (!containerWidth) return;

    // Target row height by breakpoint (tuned for "See our work" section)
    const vw = window.innerWidth || document.documentElement.clientWidth || 1024;
    let targetRowHeight = 220;
    if (vw <= 1023) targetRowHeight = 180;
    if (vw <= 639) targetRowHeight = 140;

    // Build rows by summing aspect ratios
    let row = [];
    let rowAspectSum = 0;
    const flushRow = (force = false) => {
      if (!row.length) return;

      // Compute row height that fills width
      const gapsTotal = gap * (row.length - 1);
      let rowHeight = (containerWidth - gapsTotal) / rowAspectSum;

      // Clamp to avoid extreme stretching/shrinking
      const minH = targetRowHeight * 0.75;
      const maxH = targetRowHeight * 1.35;
      if (!force) rowHeight = Math.max(minH, Math.min(maxH, rowHeight));else rowHeight = Math.max(minH, Math.min(maxH, rowHeight));
      row.forEach(({
        el,
        aspect
      }) => {
        const w = Math.max(1, Math.round(rowHeight * aspect));
        el.style.height = `${Math.round(rowHeight)}px`;
        el.style.width = `${w}px`;
      });
      row = [];
      rowAspectSum = 0;
    };
    for (const el of items) {
      const img = el.querySelector('img');
      const aspect = (() => {
        const fromData = img && img.dataset && img.dataset.aspect ? parseFloat(img.dataset.aspect) : NaN;
        if (!Number.isNaN(fromData) && fromData > 0) return fromData;
        if (img && img.naturalWidth && img.naturalHeight) return img.naturalWidth / img.naturalHeight;
        return 1.5;
      })();
      row.push({
        el,
        aspect
      });
      rowAspectSum += aspect;

      // If row is "full enough", flush it
      const estimatedWidth = rowAspectSum * targetRowHeight + gap * (row.length - 1);
      if (estimatedWidth >= containerWidth) {
        flushRow(false);
      }
    }

    // Flush last row too (so we still fill width instead of leaving a big gap)
    flushRow(true);
  }

  /**
   * Initialize lightbox for all galleries on the page
   */
  function init() {
    const galleries = document.querySelectorAll('.masonry-gallery-grid');
    galleries.forEach(gallery => {
      const images = gallery.querySelectorAll('.gallery-image');

      // Initial layout + relayout after images load
      /*
      const isJustified = gallery.dataset && gallery.dataset.justified === 'true';
      if (isJustified) {
        layoutJustified(gallery);
        images.forEach(img => {
          if (img.complete) return;
          img.addEventListener('load', () => layoutJustified(gallery), {
            once: true
          });
        });
      }
      */
      images.forEach((img, index) => {
        img.addEventListener('click', e => {
          e.preventDefault();
          openLightbox(gallery, index);
        });

        // Keyboard accessibility
        img.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openLightbox(gallery, index);
          }
        });
      });
    });

    // Create lightbox element once
    createLightbox();

    // Global keyboard events
    document.addEventListener('keydown', handleKeydown);

    // Re-layout on resize (debounced)
    /*
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('.masonry-gallery-grid[data-justified="true"]').forEach(layoutJustified);
      }, 150);
    });
    */
  }

  /**
   * Create the lightbox DOM structure
   */
  function createLightbox() {
    if (document.getElementById('gallery-lightbox')) return;
    const lightbox = document.createElement('div');
    lightbox.id = 'gallery-lightbox';
    lightbox.className = 'gallery-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Image lightbox');
    lightbox.innerHTML = `
            <div class="lightbox-overlay" aria-hidden="true"></div>
            <button class="lightbox-close" aria-label="Close lightbox">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
            <button class="lightbox-nav lightbox-prev" aria-label="Previous image">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <button class="lightbox-nav lightbox-next" aria-label="Next image">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
            <div class="lightbox-content">
                <img src="" alt="" class="lightbox-image">
            </div>
            <div class="lightbox-counter" aria-live="polite"></div>
        `;
    document.body.appendChild(lightbox);
    lightboxElement = lightbox;

    // Event listeners
    lightbox.querySelector('.lightbox-overlay').addEventListener('click', closeLightbox);
    lightbox.querySelector('.lightbox-close').addEventListener('click', closeLightbox);
    lightbox.querySelector('.lightbox-prev').addEventListener('click', showPrev);
    lightbox.querySelector('.lightbox-next').addEventListener('click', showNext);
  }

  /**
   * Open lightbox with specific gallery and image index
   */
  function openLightbox(gallery, index) {
    galleryImages = Array.from(gallery.querySelectorAll('.gallery-image'));
    currentIndex = index;
    document.body.style.overflow = 'hidden';
    lightboxElement.classList.add('is-open');
    updateLightboxImage();

    // Focus management
    lightboxElement.querySelector('.lightbox-close').focus();
  }

  /**
   * Close the lightbox
   */
  function closeLightbox() {
    document.body.style.overflow = '';
    lightboxElement.classList.remove('is-open');

    // Return focus to the image that opened the lightbox
    if (galleryImages[currentIndex]) {
      galleryImages[currentIndex].focus();
    }
  }

  /**
   * Show previous image
   */
  function showPrev() {
    currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    updateLightboxImage();
  }

  /**
   * Show next image
   */
  function showNext() {
    currentIndex = (currentIndex + 1) % galleryImages.length;
    updateLightboxImage();
  }

  /**
   * Update the lightbox image
   */
  function updateLightboxImage() {
    const img = galleryImages[currentIndex];
    const lightboxImg = lightboxElement.querySelector('.lightbox-image');
    const counter = lightboxElement.querySelector('.lightbox-counter');

    // Get full-size image URL (data attribute or src)
    const fullSrc = img.dataset.fullSrc || img.src;
    const alt = img.alt || `Image ${currentIndex + 1}`;
    lightboxImg.src = fullSrc;
    lightboxImg.alt = alt;
    counter.textContent = `${currentIndex + 1} / ${galleryImages.length}`;

    // Update nav visibility
    const prevBtn = lightboxElement.querySelector('.lightbox-prev');
    const nextBtn = lightboxElement.querySelector('.lightbox-next');
    prevBtn.style.display = galleryImages.length > 1 ? 'flex' : 'none';
    nextBtn.style.display = galleryImages.length > 1 ? 'flex' : 'none';
  }

  /**
   * Handle keyboard navigation
   */
  function handleKeydown(e) {
    if (!lightboxElement || !lightboxElement.classList.contains('is-open')) return;
    switch (e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        showPrev();
        break;
      case 'ArrowRight':
        showNext();
        break;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
})();

/******/ })()
;
//# sourceMappingURL=frontend.js.map